import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { IAction, IApiList, IPaymentSet, ITipAcceptancePaymentSet } from 'types';
import * as API from '../../../api';
import * as Actions from './actions';
import { IGetCompletePaymentSetPayload, IGetSiteAcceptancePaymentSetsPayload, IGetSitePaymentsPayload, Payments } from './types';

export function* getSitePaymentSets({ payload }: IAction<Payments, IGetSitePaymentsPayload>): any {
  try {
    const { siteId, options } = payload;
    const response: ApiResponse<IApiList<IPaymentSet>> = yield call(API.Sites.getSitePayments, siteId, options);

    yield put(Actions.getSitePaymentsSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getSitePaymentsError(error));
  }
}

export function* getSiteTipAcceptancePaymentSets({ payload }: IAction<Payments, IGetSiteAcceptancePaymentSetsPayload>) {
  try {
    const { siteId, options } = payload;

    const response: ApiResponse<IApiList<ITipAcceptancePaymentSet>> = yield call(API.Sites.getTipAcceptancePaymentsSets, siteId, options);

    yield put(Actions.getSiteTipAcceptancePaymentSetsSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getSiteTipAcceptancePaymentSetsError(error));
  }
}

export function* getCompletedPaymentSet({ payload }: IAction<Payments, IGetCompletePaymentSetPayload>) {
  const { paymentId } = payload;
  try {
    const response: ApiResponse<IPaymentSet> = yield call(API.Payments.showPayment, paymentId);
    yield put(Actions.getCompletedPaymentSetSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getCompletedPaymentSetError(error, paymentId));
  }
}

export function* watchGetPaymentSets() {
  yield takeEvery(Payments.GET_SITE_PAYMENTS_REQUEST, getSitePaymentSets);
}

export function* watchGetSiteTipAcceptancePaymentSets() {
  yield takeEvery(Payments.GET_SITE_TIP_ACCEPTANCE_PAYMENT_SETS_REQUEST, getSiteTipAcceptancePaymentSets);
}

export function* watchGetCompletePaymentSet() {
  yield takeEvery(Payments.GET_COMPLETED_PAYMENT_SET_REQUEST, getCompletedPaymentSet);
}

function* paymentsSagas() {
  yield all([fork(watchGetPaymentSets), fork(watchGetSiteTipAcceptancePaymentSets), fork(watchGetCompletePaymentSet)]);
}

export { paymentsSagas };
